module.exports = __webpack_public_path__ + "img/edit.a0d1b4ba.png";